<dx-popup
    [title]="title"
    [(visible)]="visible"
    [fullScreen]="isScreenSmall"
    [width]="550"
    [height]="height"
    (onHidden)="onClose()"
    (onShown)="onShown()"
    [wrapperAttr]="{'class':'form-popup'}"
    [showCloseButton]="true"
>
    @if (timeOffRequest) {
        <div class="row mb-3">
            <div class="col-sm-6 d-flex align-items-center">
                <strong class="me-2">Status:</strong>
                <span class="badge" [ngClass]="getBadgeClass(timeOffRequest.status)">
                {{ timeOffRequest.status | capitalCase }}
            </span>
            </div>
            <div class="col-sm-6">
                <strong>ID:</strong>
                <span class="text-muted">
                {{ timeOffRequest.number }}
            </span>
            </div>
        </div>
    }

    <dx-validation-group #validationGroup>
        <ng-content></ng-content>
    </dx-validation-group>

    <dxi-popup-toolbar-item toolbar="bottom" location="center">
        <div class="d-flex align-items-center justify-content-end gap-3">
            @if (canEdit) {
                <dx-button
                    text="Submit"
                    stylingMode="contained"
                    type="default"
                    (onClick)="onSaveClick()"
                ></dx-button>
                <dx-button
                    text="Cancel"
                    stylingMode="contained"
                    type="normal"
                    (onClick)="onClose()"
                ></dx-button>
            } @else {
                @if (canApprove) {
                    <dx-button
                        text="Approve"
                        stylingMode="contained"
                        type="success"
                        (onClick)="changeStatus(TimeOffStatus.Approved)"
                    ></dx-button>
                }
                @if (canDecline) {
                    <dx-button
                        text="Decline"
                        stylingMode="contained"
                        type="danger"
                        (onClick)="changeStatus(TimeOffStatus.Declined)"
                    ></dx-button>
                }
                @if (canWithdrawn) {
                    <dx-button
                        text="Withdrawn"
                        stylingMode="contained"
                        type="normal"
                        (onClick)="changeStatus(TimeOffStatus.Withdrawn)"
                    ></dx-button>
                }
            }
        </div>
    </dxi-popup-toolbar-item>

    @if (timeOffRequest) {
        <div class="row mt-3">
            <div class="col-sm-6 d-flex align-items-start">
                <strong class="me-2">Date Submitted:</strong>
                {{ timeOffRequest.submittedDate | date: 'longDate' }}
            </div>
            <div class="col-sm-6 d-flex flex-column align-items-end">
                @if(timeOffRequest.finalizedDate){
                    <div style="text-align: left;">
                        <div class="mb-1">
                            <strong class="me-2">Date Finalized:</strong>
                            {{ timeOffRequest.finalizedDate | date: 'longDate' }}
                        </div>
                        @if(timeOffRequest.lastModifiedByName){
                            <div>
                                <strong class="me-2">By:</strong>
                                {{ timeOffRequest.lastModifiedByName }}
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</dx-popup>
